import React from 'react';
import PlanSummary from './PlanSummary';
import PaymentFormOuter from "./PaymentFormOuter";
import { loadStripe } from "@stripe/stripe-js";
import { Elements } from "@stripe/react-stripe-js";

const BillingDetailsContent = ({
    planText,
    price,
    startDate,
    endDate
}) => {

    const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY);

    return (
        <>
            <PlanSummary planText={planText} price={price} startDate={startDate} endDate={endDate} />

            <Elements stripe={stripePromise}>
                <PaymentFormOuter />
            </Elements>
        </>
    );
};

export default BillingDetailsContent;